function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
//

import * as React from 'react';
import { css, color } from "../../../../styles/theme";
import { SvgSmallChevronUp, SvgSmallChevronDown } from "../../../../svg";
import { NO_SORT, ASCENDING, DESCENDING } from "./SortingDirection";
import { default as Styles, SORT_ARROW_SIZE } from "./SortableTableStyles";
var SortableHeader = /*#__PURE__*/function (_React$Component) {
  function SortableHeader(props, context) {
    var _this;
    _classCallCheck(this, SortableHeader);
    _this = _callSuper(this, SortableHeader, [props, context]);
    _this.state = {
      hovered: false,
      focused: false
    };
    return _this;
  }
  _inherits(SortableHeader, _React$Component);
  return _createClass(SortableHeader, [{
    key: "handleKeyPress",
    value: function handleKeyPress(key) {
      var _this$props = this.props,
        currentColumn = _this$props.currentColumn,
        onChange = _this$props.onChange;
      if (key === 'Enter' || key === ' ') {
        onChange(currentColumn, this.getNextDirection());
      }
    }
  }, {
    key: "getNextDirection",
    value: function getNextDirection() {
      var _this$props2 = this.props,
        sortingColumn = _this$props2.sortingColumn,
        sortingDirection = _this$props2.sortingDirection,
        currentColumn = _this$props2.currentColumn;
      if (currentColumn === sortingColumn) {
        switch (sortingDirection) {
          case NO_SORT:
            return ASCENDING;
          case ASCENDING:
            return DESCENDING;
          default:
            return NO_SORT;
        }
      } else {
        return ASCENDING;
      }
    }
  }, {
    key: "isActivated",
    value: function isActivated() {
      var _this$props3 = this.props,
        sortingColumn = _this$props3.sortingColumn,
        sortingDirection = _this$props3.sortingDirection,
        currentColumn = _this$props3.currentColumn;
      return sortingColumn === currentColumn && sortingDirection !== NO_SORT;
    }
  }, {
    key: "getOpacity",
    value: function getOpacity() {
      var _this$state = this.state,
        focused = _this$state.focused,
        hovered = _this$state.hovered;
      if (this.isActivated()) {
        return 1;
      } else {
        return hovered || focused ? 0.5 : 0;
      }
    }
  }, {
    key: "renderSortArrow",
    value: function renderSortArrow() {
      var _this$props4 = this.props,
        sortingColumn = _this$props4.sortingColumn,
        sortingDirection = _this$props4.sortingDirection,
        currentColumn = _this$props4.currentColumn;
      var isSortingCurrentColumn = sortingColumn === currentColumn;
      if (isSortingCurrentColumn && sortingDirection === DESCENDING) {
        return /*#__PURE__*/React.createElement(SvgSmallChevronUp, {
          title: "Sort Descending",
          size: SORT_ARROW_SIZE
        });
      } else {
        var title = isSortingCurrentColumn ? 'Sort Ascending' : 'Default Sort';
        return /*#__PURE__*/React.createElement(SvgSmallChevronDown, {
          title: title,
          size: SORT_ARROW_SIZE
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props5 = this.props,
        isVisibleHeader = _this$props5.isVisibleHeader,
        currentColumn = _this$props5.currentColumn,
        header = _this$props5.header,
        onChange = _this$props5.onChange;
      var hovered = this.state.hovered;
      return /*#__PURE__*/React.createElement("div", _extends({}, css(Styles.sortableCell), {
        style: {
          color: this.isActivated() && color.primaryText
        },
        role: "button",
        tabIndex: isVisibleHeader ? 0 : -1,
        onClick: function onClick() {
          return onChange(currentColumn, _this2.getNextDirection());
        },
        onFocus: function onFocus() {
          return _this2.setState({
            focused: true
          });
        },
        onBlur: function onBlur() {
          return _this2.setState({
            focused: false
          });
        },
        onKeyPress: function onKeyPress(event) {
          return _this2.handleKeyPress(event.key);
        },
        onMouseEnter: function onMouseEnter() {
          return _this2.setState({
            hovered: true
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({
            hovered: false
          });
        }
      }), /*#__PURE__*/React.createElement("span", null, typeof header === 'function' ? header(isVisibleHeader) : header), /*#__PURE__*/React.createElement("span", _extends({}, css(Styles.sortArrow), {
        style: {
          opacity: this.getOpacity()
        }
      }), this.renderSortArrow()));
    }
  }]);
}(React.Component);
export default SortableHeader;